export const BILLING_GROUP_META_CONTRACT_URN = 'contract_urn';
export const BILLING_GROUP_META_CONTRACT_ITERATION_URN = 'contract_iteration_urn';
export const BILLING_GROUP_META_QUOTATION_URN = 'quotation_urn';